import React from "react"
import TableIcons from "../../table/TableIcons"
import MaterialTable from "@material-table/core"
import {ProcessedEventV2} from "../../../dtos/eventResponse"
import {Typography} from "@mui/material"
import {makeStyles} from "tss-react/mui"

interface EventsTableProps {
	events: ProcessedEventV2[]
}
const useStyles = makeStyles()({
	container: {
		display: "flex",
		paddingBottom: "24px",
		flexDirection: "column",
		alignItems: "flex-end",
		gap: "24px",
		alignSelf: "stretch",
		width: "100%",
	},
	detail: {
		display: "table",
		alignItems: "baseline",
		color: "var(--text-primary, rgba(0, 0, 0, 0.87))",
		fontFeatureSettings: "'liga' off, 'clig' off",
		fontSize: "14px",
		fontStyle: "normal",
		lineHeight: "143%",
		letterSpacing: "0.17px",
	},
	detailsColumn: {
		padding: "6px 16px",
		alignItems: "center",
		flex: "1 0 0",
	},
	dateColumn: {
		display: "flex",
		padding: "4px 0px 4px 16px",
		alignItems: "center",
		gap: "12px",
		flex: "1 0 0",
	},
	date: {
		color: "var(--text-primary, rgba(0, 0, 0, 0.87))",
		fontFeatureSettings: "'liga' off, 'clig' off",
		fontSize: "14px",
		fontStyle: "normal",
		fontWeight: 400,
		lineHeight: "143%",
		letterSpacing: "0.17px",
	},
})

export default function EventsTable(props: EventsTableProps) {
	const {classes} = useStyles()
	const displayDetail = (title: string, detail: string) => {
		return (
			<Typography className={classes.detail}>
				{<span style={{fontWeight: 700}}>{`${title}:`}</span>}
				{`${" "} ${detail}`}
			</Typography>
		)
	}
	const getEclipseColor = (tag: string) => {
		switch (tag) {
			case "update":
				return "#42A5F5"
			case "warning":
				return "#FF9800"
			case "success":
				return "#000000"
			default:
				return "#00000061"
		}
	}
	return (
		<MaterialTable
			icons={TableIcons}
			title=""
			columns={[
				{
					title: "Date",
					field: "dateTime",
					type: "datetime",
					sorting: true,
					render: (rowData) => (
						<div className={classes.dateColumn}>
							<svg
								xmlns="http://www.w3.org/2000/svg"
								width="13"
								height="12"
								viewBox="0 0 13 12"
								fill="none"
							>
								<circle cx="6.5" cy="6" r="6" fill={getEclipseColor(rowData.tag)} />
							</svg>
							<Typography className={classes.date}>{`${new Date(
								rowData.dateTime
							).toString()}`}</Typography>
						</div>
					),
				},
				{
					title: "Event",
					field: "type",
				},
				{
					title: "Details",
					render: (rowData) => (
						<div className={classes.detailsColumn}>
							{rowData.description &&
								rowData.description !== "" &&
								displayDetail("Description", rowData.description)}
							{rowData.source && rowData.source !== "" && displayDetail("Source", rowData.source)}
							{rowData.eventSubType &&
								rowData.eventSubType !== "" &&
								displayDetail("Event sub type", rowData.eventSubType)}
							{rowData.reason && rowData.reason !== "" && displayDetail("Reason", rowData.reason)}
							{rowData.updatedArrivalDate &&
								rowData.updatedArrivalDate !== "" &&
								displayDetail(
									"Updated arrival date",
									new Date(rowData.updatedArrivalDate).toString()
								)}
							{rowData.delayedReason &&
								rowData.delayedReason !== "" &&
								displayDetail("Delayed reason", rowData.delayedReason)}
						</div>
					),
				},
			]}
			data={props.events}
			options={{
				filtering: false,
				search: false,
				toolbar: false,
				headerStyle: {
					color: "var(--text-primary, rgba(0, 0, 0, 0.87))",
					fontFeatureSettings: "'liga' off, 'clig' off",
					fontStyle: "normal",
					fontSize: "14px",
					fontWeight: "500",
					lineHeight: "24px",
					letterSpacing: "0.17px",
					alignItems: "center",
				},
			}}
			style={{width: "100%"}}
		/>
	)
}
